import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const _isFalsy = (val) =>
  _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}
// requestCancel.source = requestCancel.token.source()

const dashboard = {
  namespaced: true,

  state: {
    customers: [],
    prospects: [],
    active_customers: [],
    domiciliated_customers: [],
    validation_requests: [],
    stats: null,
    sortParams: {
      orderBy: "created_at",
      sortedBy: "desc",
    },
    requestCancel,
  },

  mutations: {
    [types.DASHBOARD_STATS_RECEIVED](state, payload) {
      state.stats = payload
    },

    [types.DASHBOARD_VALIDATION_REQUESTS_RECEIVED](state, payload) {
      state.validation_requests = payload.validation_requests
    }
  },

  actions: {
    get_dashboard_stats({ commit }, params) {
      return api.get_dashboard_stats(params)
        .then((response) => commit(types.DASHBOARD_STATS_RECEIVED, response.data))
    }
  }
}

export default dashboard



// WEBPACK FOOTER //
// ./client/store/modules/dashboard.js